export var PayloadType;
(function (PayloadType) {
    PayloadType["TIMING"] = "timing";
    PayloadType["GAUGE"] = "gauge";
    PayloadType["INCREMENT"] = "increment";
    PayloadType["DECREMENT"] = "decrement";
})(PayloadType || (PayloadType = {}));
